<!-- KPI Metric Cards -->
<div class="row g-3 mb-4">
  <div class="col-lg col-md-6">
    <app-metric-card
      [title]="'Documents'"
      [currentValue]="analyzedDocCount()"
      [hidePrevious]="true"
      [hideComparison]="true"
      [isLoading]="isLoading()"
      [showLeftBorder]="true"
      leftBorderColor="var(--bs-primary)"
    ></app-metric-card>
  </div>
  <div class="col-lg col-md-6">
    <app-metric-card
      [title]="'Validated'"
      [currentValue]="totalValidated()"
      [hidePrevious]="true"
      [hideComparison]="true"
      [isLoading]="isLoading()"
      [showLeftBorder]="true"
      leftBorderColor="#28a745"
    ></app-metric-card>
  </div>
  <div class="col-lg col-md-6">
    <app-metric-card
      [title]="'Not Validated'"
      [currentValue]="totalMismatches()"
      [hidePrevious]="true"
      [hideComparison]="true"
      [isLoading]="isLoading()"
      [showLeftBorder]="true"
      leftBorderColor="#dc3545"
    ></app-metric-card>
  </div>
  <div class="col-lg col-md-6">
    <app-metric-card
      [title]="'Recommended'"
      [currentValue]="totalRecommended()"
      [hidePrevious]="true"
      [hideComparison]="true"
      [isLoading]="isLoading()"
      [showLeftBorder]="true"
      leftBorderColor="#fd7e14"
    ></app-metric-card>
  </div>
  <div class="col-lg col-md-6">
    <app-metric-card
      [title]="'Unverifiable'"
      [currentValue]="totalUnverifiable()"
      [hidePrevious]="true"
      [hideComparison]="true"
      [isLoading]="isLoading()"
      [showLeftBorder]="true"
      leftBorderColor="#adb5bd"
    ></app-metric-card>
  </div>
</div>

<!-- Header + Actions -->
<div class="d-flex justify-content-between align-items-center mb-3">
  <h5 class="mb-0">Uploaded Documents</h5>
  <div class="d-flex gap-2">
    <button class="btn btn-outline-primary btn-sm" (click)="viewAggregate.emit()">
      View Aggregate Report
    </button>
    <button class="btn btn-primary btn-sm" (click)="showUploadDialog.set(true)">
      Upload Document
    </button>
  </div>
</div>

<!-- Document Cards -->
<div class="row g-3">
  @for (doc of documents(); track doc.id) {
    <div class="col-lg-6 col-xl-4">
      <div
        class="card h-100 document-card"
        [class.document-card--clickable]="doc.status === 'analyzed'"
        (click)="onDocumentClick(doc)"
      >
        <div class="card-body">
          <div class="d-flex justify-content-between align-items-start mb-2">
            <div class="d-flex align-items-center gap-2">
              <span class="file-type-badge" [class.file-type-badge--pdf]="doc.file_type === 'pdf'" [class.file-type-badge--docx]="doc.file_type === 'docx'">
                {{ doc.file_type | uppercase }}
              </span>
              <h6 class="card-title mb-0 text-truncate" style="max-width: 220px" [title]="doc.file_name">
                {{ doc.file_name }}
              </h6>
            </div>
            <span class="badge" [class]="getStatusClass(doc.status)">{{ getStatusLabel(doc.status) }}</span>
          </div>

          <div class="text-muted small mb-2">
            Uploaded {{ formatDate(doc.uploaded_at) }} by {{ doc.uploaded_by }}
          </div>

          @if (doc.domains.length > 0) {
            <div class="mb-2">
              @for (domain of doc.domains; track domain) {
                <span class="badge bg-light text-dark me-1 mb-1 small">{{ getDomainDisplayName(domain) }}</span>
              }
            </div>
          }

          @if (doc.report_card) {
            <div class="d-flex justify-content-between align-items-center mt-3 pt-2 border-top">
              <span class="badge" [class]="getAlignmentConfig(doc.report_card.alignment_label).bootstrapClass">
                {{ getAlignmentConfig(doc.report_card.alignment_label).label }}
              </span>
              <span class="text-muted small">{{ doc.statement_count }} statements</span>
            </div>
          }

          @if (doc.status === 'processing') {
            <div class="mt-3 pt-2 border-top">
              <div class="progress" style="height: 4px">
                <div class="progress-bar progress-bar-striped progress-bar-animated bg-info" style="width: 65%"></div>
              </div>
              <span class="text-muted small mt-1 d-block">Analyzing document...</span>
            </div>
          }

          @if (doc.status === 'error') {
            <div class="mt-3 pt-2 border-top text-danger small">
              Analysis failed. Click to retry.
            </div>
          }
        </div>
      </div>
    </div>
  } @empty {
    <div class="col-12">
      <div class="text-center py-5 text-muted">
        <p class="mb-2">No documents uploaded yet.</p>
        <button class="btn btn-primary btn-sm" (click)="showUploadDialog.set(true)">
          Upload Your First Document
        </button>
      </div>
    </div>
  }
</div>

<!-- Upload Dialog -->
@if (showUploadDialog()) {
  <app-document-upload-dialog
    (uploaded)="onUploadComplete($event)"
    (cancelled)="showUploadDialog.set(false)"
  ></app-document-upload-dialog>
}
